import { useTranslation } from 'react-i18next'
import { Controller, Control } from 'react-hook-form'
import {
  InputBase,
  InputContainer,
  InputLabelContainer,
  InputSelect,
  InputSelectContentHeader,
  InputSelectSearchableContent,
  InputSelectSearchableItem,
  InputSelectSearchableTrigger,
  InputSelectStatefulInput,
  InputSelectTrailingContainer,
  ListItem,
  ListItemMainContent,
  ListItemParagraph,
  ListItemTrailing,
} from '@sweetspot/scramble-ds'
import { Timezone } from '../types'

interface TimezoneSelectorProps {
  control: Control<any>
  name: string
  formattedTimezones: Timezone[]
  isLoading?: boolean
}

export const TimezoneSelector = ({
  control,
  name,
  formattedTimezones,
  isLoading = false,
}: TimezoneSelectorProps) => {
  const { t } = useTranslation()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <InputSelect withSearch>
          <InputBase className="w-full" disabled={isLoading}>
            <InputLabelContainer className="mb-0.5">
              {t('memberships.membershipImports.heading_timezone')}
            </InputLabelContainer>
            <InputSelectSearchableTrigger asChild>
              <InputContainer className="ring-border-stroke-subtle">
                <InputSelectStatefulInput
                  placeholder={t('memberships.membershipImports.select_timezone')}
                  className="text-ellipsis border text-base"
                  value={field.value?.name}
                  disabled={isLoading}
                  readOnly
                />
                <InputSelectTrailingContainer />
              </InputContainer>
            </InputSelectSearchableTrigger>
          </InputBase>
          <InputSelectSearchableContent usePortal={false} showScrollbar>
            <InputSelectContentHeader>{t('words.timezones')}</InputSelectContentHeader>
            {formattedTimezones.map((timezone) => (
              <InputSelectSearchableItem
                key={timezone.id}
                onSelect={() => {
                  field.onChange(timezone)
                }}
              >
                <ListItem className="ml-2 h-full w-full min-w-fit justify-between gap-2">
                  <ListItemMainContent className="justify-center py-1">
                    <ListItemParagraph className="text-content-base">
                      {timezone?.name}
                    </ListItemParagraph>
                  </ListItemMainContent>
                  {field.value?.name === timezone?.name && (
                    <ListItemTrailing>
                      <i className="fa-regular fa-check mr-3 h-4 w-4" />
                    </ListItemTrailing>
                  )}
                </ListItem>
              </InputSelectSearchableItem>
            ))}
          </InputSelectSearchableContent>
        </InputSelect>
      )}
    />
  )
}
